import React from 'react';
import styles from './BaseConfirm.module.css';
import BaseModal from './BaseModal';

class BaseConfirm extends React.Component {
  render() {
    let {
      icon,
      title,
      subtitle,
      confirmButtonText,
      cancelButtonText,
      onConfirmed,
      onCancelled
    } = this.props;

    return (
      <BaseModal
        show={true}
        hasHeader={false}
        hasFooter={false}
        onClose={onCancelled}
        width="350px"
      >
        <div className={styles.confirmContainer}>
          <img className={styles.confirmIcon} src={`./${icon}.svg`} alt="confirmation icon" />
          <span className={styles.confirmTitle}>{title}</span>
          <span className={styles.confirmSubtitle}>{subtitle}</span>
          <div className={styles.buttonsContainer}>
            <button className={styles.confirm} onClick={onConfirmed}>{confirmButtonText}</button>
            <button className={styles.cancel} onClick={onCancelled}>{cancelButtonText}</button>
          </div>
        </div>
      </BaseModal>
    );
  }
}

BaseConfirm.defaultProps = {
  icon: 'warning',
  title: 'Are you sure?',
  subtitle: 'You must confirm to continue',
  confirmButtonText: 'Confirm',
  cancelButtonText: 'Cancel',
  onConfirmed: () => { },
  onCancelled: () => { }
};

export default BaseConfirm;
